import React from 'react'
import { AlertCircle, Ban } from 'lucide-react'

import { nutrimaticLabels } from '@/nutrimatic'
import { cn } from '@/lib/utils'
import { Button } from '@/ui/button'

export type LiquidityMobileOutcomeKind = 'cancelled' | 'error'

type LiquidityNutrimaticMobileOutcomeViewProps = {
  kind: LiquidityMobileOutcomeKind
  operation: 'add' | 'remove'
  detail?: string | null
  onBackToForm: () => void
  onRetry?: () => void
}

function outcomeCopy(kind: LiquidityMobileOutcomeKind, operation: 'add' | 'remove') {
  const labels = nutrimaticLabels.mobileSimple
  if (kind === 'cancelled') {
    return {
      kicker: operation === 'add' ? labels.liquidityCancelledAddKicker : labels.liquidityCancelledRemoveKicker,
      title: labels.liquidityCancelledTitle,
    }
  }
  return {
    kicker: operation === 'add' ? labels.liquidityErrorAddKicker : labels.liquidityErrorRemoveKicker,
    title: labels.liquidityErrorTitle,
  }
}

export function LiquidityNutrimaticMobileOutcomeView({
  kind,
  operation,
  detail,
  onBackToForm,
  onRetry,
}: LiquidityNutrimaticMobileOutcomeViewProps) {
  const copy = outcomeCopy(kind, operation)
  const Icon = kind === 'cancelled' ? Ban : AlertCircle

  return (
    <div className="nm-mobile-simple__outcome-stage flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="nm-mobile-simple__outcome">
        <span className="nm-mobile-simple__hero-brand nm-mobile-simple__outcome-brand">
          {nutrimaticLabels.mobileSimple.productBrand}
        </span>
        <p className="nm-mobile-simple__outcome-kicker">{copy.kicker}</p>
        <div
          className={cn(
            'nm-mobile-simple__outcome-icon',
            kind === 'cancelled'
              ? 'nm-mobile-simple__outcome-icon--cancelled'
              : 'nm-mobile-simple__outcome-icon--error',
          )}
        >
          <Icon className="size-9" aria-hidden />
        </div>
        <h2 className="nm-mobile-simple__outcome-title">{copy.title}</h2>
        {detail ? (
          <p className="nm-mobile-simple__outcome-sub" role={kind === 'error' ? 'alert' : undefined}>
            {detail}
          </p>
        ) : null}
      </div>
      <div className="nm-mobile-simple__footer nm-mobile-simple__footer--stacked">
        {kind === 'error' && onRetry ? (
          <Button type="button" className="nm-mobile-simple__cta" onClick={onRetry}>
            {nutrimaticLabels.mobileSimple.retryLiquidityAction}
          </Button>
        ) : null}
        <Button
          type="button"
          className={cn(
            'nm-mobile-simple__cta',
            kind === 'error' && onRetry && 'nm-mobile-simple__cta--secondary',
          )}
          onClick={onBackToForm}
        >
          {nutrimaticLabels.mobileSimple.backToLiquidityForm}
        </Button>
      </div>
    </div>
  )
}
